<div class="container">
  <h2>Test Connection</h2>

  <div class="loading-container" *ngIf="!loaded">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <div *ngIf="loaded">
    <label>Send To:</label>
    <input
      type="text"
      [(ngModel)]="sendTo"
      placeholder="Enter mobile or email"
      class="input-box"
    />

    <label>Message:</label>
    <textarea
      [(ngModel)]="inputValue"
      placeholder="Write message here..."
      class="input-box textarea"
    ></textarea>

    <div class="button-group">
      <ion-button color="primary" (click)="sendEmailTest()">
        Email Test
      </ion-button>

      <ion-button color="success" (click)="sendSmsTest()">
        SMS Test
      </ion-button>
    </div>

    <!-- Result -->
    <div
      *ngIf="result"
      [ngClass]="{
        'success-text': result === 'Success',
        'error-text': result !== 'Success'
      }"
    >
      {{ result }}
    </div>
  </div>
</div>